<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick" style="min-width: 25%;">
  <template #header>标记说明</template>

  <template #body>
    <h1>数采标记</h1>
    <p>
      <span>N: 正常</span>
    </p>
    <p>
      <span>D: 数据不足,有效</span>
      <span>d: 数据不足,无效</span>
    </p>
    <p>
      <span>B: 仪器故障,有效</span>
      <span>b: 仪器故障,无效</span>
    </p>
    <p>
      <span>C: 仪器校准,有效</span>
      <span>c: 仪器校准,无效</span>
    </p>
    <p>
      <span>P: 站房停电,有效</span>
      <span>p: 站房停电,无效</span>
    </p>
    <p>
      <span>H: 超量程上限,有效</span>
      <span>h: 超量程上限,无效</span>
    </p>
    <p>
      <span>L: 超量程下限,有效</span>
      <span>l: 超量程下限,无效</span>
    </p>
    <p>
      <span>M: 仪器维护,有效</span>
      <span>m: 仪器维护,无效</span>
    </p>
    <h1>审核标记</h1>
    <p>
      <span>R: 保留</span>
      <span>O: 剔除</span>
    </p>
    <h1>重积分标记</h1>
    <p>
      <span><section style="background-color:#409EFF"></section><label>重积分</label></span>
      <span><section style="background-color:#606266"></section><label>原始</label></span>
    </p>
  </template>

  <template #footer>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../BaseEditor'

export default {
  name: 'MarkDes',
  extends: BaseEditor
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 17px;
  margin: 8px 0;
}
p {
  margin: 5px 0;
  display: flex;

  span {
    display: inline-block;
    width: 50%;
    text-align: left;
    display: flex;
    align-items: center;

    section {
      width: 15px;
      height: 15px;
    }
  }

  :nth-child(2) {
    margin-left: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/00Data-Download/Editor.vue